export const classes = {
  list: 'mt-4',
  listItem: 'mb-8',
};
